import { render } from "./Resultaat.vue?vue&type=template&id=69ce3588&scoped=true&ts=true"
import script from "./Resultaat.vue?vue&type=script&lang=ts"
export * from "./Resultaat.vue?vue&type=script&lang=ts"

import "./Resultaat.vue?vue&type=style&index=0&id=69ce3588&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ce3588"]])

export default __exports__